import { RiReactjsLine } from "react-icons/ri";
import { SiMysql } from "react-icons/si";
import { SiAdobexd } from "react-icons/si";
import { FaShoppingCart } from "react-icons/fa";

const data = [
  {
    id: 1,
    icon: <RiReactjsLine />,
    title: "Frontend Development",
    desc: "Building responsive and dynamic websites using React which can be accessible on all devices.",
  },
  {
    id: 2,
    icon: <SiMysql />,
    title: "MySQL",
    desc: "Designing and managing relational databases to ensure efficient data storage and retrieval.",
  },
  {
    id: 3,
    icon: <SiAdobexd />,
    title: "UI/UX Design",
    desc: "Creating user-friendly and visually appealing designs which are modern and intuitive.",
  },
  {
    id: 4,
    icon: <FaShoppingCart />,
    title: "D-Marketing",
    desc:
      "Promoting products and services through digital channels to reach a wider audience and drive sales.",
  },
];

export default data;
